import { Component, OnInit, OnDestroy } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { NotfLayoutStoreActions } from 'src/app/_apps/notf/store/';
import { selectAllMessages } from 'src/app/_apps/notf/store/notf.reducer';
import { IAuroraState } from 'src/app/_apps/aurora.state';

@Component({
    selector: 'aa-header-notifications',
    templateUrl: './header-notifications.component.html',
    styleUrls: [
        './header-notifications.component.scss'
    ],
    standalone: false
})
export class HeaderNotificationsComponent implements OnInit, OnDestroy
{
    private destroyator = new Subject();
    notfCounter: number = 0;
    notfImportantCounter: number = 0;

    constructor(private store: Store<IAuroraState>) { }

    ngOnInit ()
    {
        this.listenToNotifs();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    show (): void
    {
        this.store.dispatch(NotfLayoutStoreActions.NotfLayoutMesgShowHide({status: true}));
    }

    private listenToNotifs (): void
    {
        this.store
            .pipe(
                select(selectAllMessages),
                tap((result) => this.notfCounter = result.length),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }
}
